import { useSyncExternalStore } from 'react'

import {
  INSIGHTS_PREFERENCES_EVENT,
  insightsPreferencesStorage,
  type InsightsPreferences
} from '../utils/insightsPreferencesStorage'

function subscribe(onChange: () => void): () => void {
  window.addEventListener(INSIGHTS_PREFERENCES_EVENT, onChange)
  window.addEventListener('storage', onChange)
  return () => {
    window.removeEventListener(INSIGHTS_PREFERENCES_EVENT, onChange)
    window.removeEventListener('storage', onChange)
  }
}

// useSyncExternalStore requires a stable reference when the underlying value
// hasn't changed; otherwise React warns "getSnapshot should be cached".
let cached: InsightsPreferences = insightsPreferencesStorage.get()

function getSnapshot(): InsightsPreferences {
  const next = insightsPreferencesStorage.get()
  // Refresh the cached reference only when a value actually changed, so new
  // preferences don't need a hand-written per-field comparison here
  if (JSON.stringify(next) !== JSON.stringify(cached)) {
    cached = next
  }
  return cached
}

interface UseInsightsPreferencesResult {
  prefs: InsightsPreferences
  setPrefs: (next: Partial<InsightsPreferences>) => void
}

const useInsightsPreferences = (): UseInsightsPreferencesResult => {
  const prefs = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
  return { prefs, setPrefs: insightsPreferencesStorage.set }
}

export default useInsightsPreferences
